import React, { useState } from 'react';
import { ActivityPanel } from './ActivityPanel';
import { ActivityBadgeTrigger } from './ActivityBadgeTrigger';
import { JobNavigationDeps } from '../utils/jobNavigation';

interface GlobalJobPanelProps extends JobNavigationDeps {
  quietCreativeTypeFqn?: string | null;
}

export const GlobalJobPanel: React.FC<GlobalJobPanelProps> = ({
  quietCreativeTypeFqn,
  navigateToStep,
  openCreativeEditor,
  resolveIteration,
  resolveFeedbackIdForJob,
  scrollToFeedback,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <ActivityBadgeTrigger
        isOpen={isOpen}
        onToggle={() => setIsOpen((open) => !open)}
        quietCreativeTypeFqn={quietCreativeTypeFqn}
      />
      <ActivityPanel
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        navigateToStep={navigateToStep}
        openCreativeEditor={openCreativeEditor}
        resolveIteration={resolveIteration}
        resolveFeedbackIdForJob={resolveFeedbackIdForJob}
        scrollToFeedback={scrollToFeedback}
      />
    </>
  );
};

export default GlobalJobPanel;
